module.exports = __webpack_public_path__ + "static/media/medicheckLogo.887dcbc5.svg";